import Vue from "vue";
import { CellType, CellState, Provider } from "js/crossword/types";
import { Puzzle } from "js/crossword/Puzzle";
import { canRatePuzzle } from "js/crossword/ratingStore";
import CalendarProgressPanel from "./CalendarProgressPanel";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";
import PuzzleRating from "./PuzzleRating";
import { getSettingsData, ISettingsData, saveSettings } from 'js/crossword/settingsData';

declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    puzzle: Puzzle,
  },
  data() {
    let settings: ISettingsData = getSettingsData();
    let currMonth: number = new Date().getMonth(); //0 = january
    if (settings.currMonth !== currMonth) {
      settings.currMonth = currMonth;
      settings.solvedThisMonth = 0;
    }
    settings.solvedThisMonth += 1;
    saveSettings();
    return {
      solvedThisMonth: settings.solvedThisMonth,
      ratingPossible: canRatePuzzle(this.puzzle.data.id),
      ratingOpened: false,
    };
  },
  computed: {
    timeFormated(): string {
      const allSec = Math.floor(this.puzzle.data.time / 1000);
      const min = Math.floor(allSec / 60);
      return `${min}:${(allSec % 60).toString().padStart(2, "0")}`;
    },
    percentageWithoutHelp(): number {
      const regularCells = this.puzzle.data.cells.filter((cell) => cell.type === CellType.Regular);
      const notRevealed = regularCells.filter((cell) => cell.state !== CellState.Revealed);
      return notRevealed.length / regularCells.length;
    },
  },
  methods: {
    close() {
      sdkHandler.trigger('interstitialAd', { callback: function() {
        this.$emit("close");
        this.$emit("openCalendar");
      }}, this);
    },
    closeRating() {
      this.ratingPossible = false;
      this.ratingOpened = false;
    },
  },
  render() {
    return (
      <PopupContainer
        customClasses={["popup--completePopup"]}
        handleClose={() => sdkHandler.trigger('interstitialAd', { callback: function() {
          this.$emit("close");
        }}, this)}
      >
        { !this.ratingOpened
          ? <div>
            <div style="text-align: center; line-height: 1.5">
              <img src="images/Victory_Trophy.svg" style="width: 180px" />
              <h3>{this.localization.get("Congratulations!")}</h3>

              {this.localization.get("You solved the whole puzzle.")}
            </div>

            <CalendarProgressPanel data={{
              completed: this.solvedThisMonth,
              rate: this.percentageWithoutHelp,
              rateLabel: this.localization.get("Without help"),
              time: this.puzzle.data.time,
              timeLabel: this.localization.get("Time"),
            }} />

            <PopupButtons buttons={[{
              label: this.localization.get("Play more puzzles"),
              onClick: this.close,
            }]} />
          </div>
          : null}

        { this.ratingPossible
          ? <PuzzleRating
            puzzleId={this.puzzle.data.id}
            onOpenRating={() => this.ratingOpened = true}
            onCloseRating={() => this.ratingOpened = false}
            onClosePopup={this.closeRating}
          />
          : null}
      </PopupContainer>
    );
  },
});